import { Component, Input } from '@angular/core';

@Component({
  selector: 'ion-table',
  templateUrl: 'ion-table.html'
})
export class IonTableComponent {

  @Input() public data: any = {
    header: {
      title: 'Titulo',
      cols: ["col 1", "col 2", "col 3"]
    },
    body: [
      ['Alimentación', 'Necesario', 4500],
      ['Alimentación', 'Estilo de Vida', 789],
      ['Alimentación', 'Necesario', 4500],
      ['Alimentación', 'Necesario', 4500]
    ]
  };

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/components/ion-table/ion-table.ts